// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__m7C8e","validationTips":"StatementDescriptor_validationTips__an1n1"};